// src/hooks/useLadderMe.ts
import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { fetchLadderMe, ladderKeys, type LadderMe } from "@/lib/services/ladder-portal";

/** Who am I in this ladder — read once per page (contract §5). */
export function useLadderMe(ladderId: string | undefined): UseQueryResult<LadderMe> {
  return useQuery({
    queryKey: ladderKeys.me(ladderId ?? ""),
    queryFn: () => fetchLadderMe(ladderId!),
    enabled: !!ladderId,
    staleTime: 5 * 60_000,
  });
}
